import {Log} from '@aboutyou/mlm';

// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const clear: typeof window.sessionStorage.clear = () => {
  try {
    return window.sessionStorage.clear();
  } catch (error: unknown) {
    Log.warn('@aboutyou/utils', 'Not able to clear the session storage', {
      error: error as Error,
    });
  }
};

// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const getItem: typeof window.sessionStorage.getItem = key => {
  try {
    return window.sessionStorage.getItem(key);
  } catch (error: unknown) {
    Log.warn(
      '@aboutyou/utils',
      'Not able to retrieve an item from session storage',
      {
        error: error as Error,
        itemKey: key,
      },
    );
    return null;
  }
};

export const getParsedItem = (key: string) => {
  const rawValue = getItem(key);
  try {
    if (!rawValue) {
      return null;
    }

    return JSON.parse(rawValue);
  } catch (error: unknown) {
    // This error can be thrown also for malformed strings
    return rawValue;
  }
};

// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const removeItem: typeof window.sessionStorage.removeItem = key => {
  try {
    return window.sessionStorage.removeItem(key);
  } catch (error: unknown) {
    Log.warn(
      '@aboutyou/utils',
      'Not able to remove an item from session storage',
      {
        error: error as Error,
        itemKey: key,
      },
    );
  }
};

// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const setItem: typeof window.sessionStorage.setItem = (key, value) => {
  try {
    return window.sessionStorage.setItem(key, value);
  } catch (error: unknown) {
    Log.warn(
      '@aboutyou/utils',
      'Not able to set an item into session storage',
      {
        error: error as Error,
        itemKey: key,
      },
    );
  }
};
